import { __assign, __spreadArray } from "tslib";
import { setOpacity } from './colorUtils';
import * as moment from 'moment-timezone';
import { DEMO_CALENDARS_IDS } from '../constants';
import MomentEnum from '../enums/MomentEnum';
export var datesConverter = function (dates, timezone, isPrivateEventsShown) {
    var longEvents = Object.values(dates) // separate long events
        .flat()
        .filter(function (event) {
        //@ts-ignore
        return +event.orderPosition[0] === 1 && event.id === event.originEventId;
    })
        .map(function (e) {
        //@ts-ignore
        var diff = moment(e.endDate).diff(moment(e.startDate), 'hours');
        //@ts-ignore
        var duration = e.duration;
        if (diff === 24) {
            duration = 1;
        }
        //@ts-ignore
        var endDate = e.endDate;
        if (duration > 1) {
            //@ts-ignore
            endDate = moment(e.endDate).add(1, 'day').format('YYYY-MM-DD');
        }
        // UPDATE FROM
        //@ts-ignore
        var end = e.endDate;
        //@ts-ignore
        var start = e.startDate;
        if (
        //@ts-ignore
        (e.orderPosition !== '' &&
            !(end.includes('T') || start.includes('T'))) ||
            (end.includes('T') && start.includes('T'))) {
            end = moment(end)
                .add(1, MomentEnum.days)
                .format(MomentEnum.yearMonthDay);
        }
        // UPDATE TO
        //@ts-ignore
        return __assign(__assign({}, e), { duration: duration, endDate: endDate });
    });
    //@ts-ignore
    var events = Object.values(dates)
        .flat()
        //@ts-ignore
        .filter(function (item) { return item.originEventId === ''; });
    var eventsArr = __spreadArray(__spreadArray([], events, true), longEvents, true).sort(
    //@ts-ignore
    function (event1, event2) { return moment(event1.startDate) - moment(event2.startDate); });
    eventsArr.map(function (event) {
        var diff = moment(event.endDate).diff(moment(event.startDate), 'hours');
        // if (event.recurringEventId && recurrenceArr) {
        //   const res = recurrenceArr.find(
        //     (el) => el.recurrenceId === event.recurringEventId,
        //   );
        //   typeof res !== 'undefined' && (event.recurrence = res.recurrence);
        // }
        if (diff >= 24) {
            event.isAllDay = true;
        }
    });
    var arrDateIndex = [];
    var convertedEvents = eventsArr.map(function (event) {
        var eventColor = event.eventColor.replace(/nan/gi, 0);
        eventColor = setOpacity(1, eventColor);
        var momentEndTime = moment(event.endDate);
        var momentNow = moment();
        var pastEvent = momentEndTime.diff(momentNow) < 0;
        var start = event.startDate;
        var end = event.endDate;
        if (DEMO_CALENDARS_IDS.includes(event.calendarId)) {
            start = moment(event.startDate).tz(timezone).format();
            end = moment(event.endDate).tz(timezone).format();
        }
        if (!isPrivateEventsShown && event.isPrivate) {
            return {};
        }
        var tabIndex;
        //@ts-ignore
        if (arrDateIndex.indexOf(moment(start).format()) !== -1) {
            //@ts-ignore
            tabIndex = arrDateIndex.indexOf(moment(start).format());
        }
        else {
            //@ts-ignore
            arrDateIndex.push(moment(start).format());
            tabIndex = arrDateIndex.length - 1;
        }
        // FIXME
        // if (
        //   (event.orderPosition !== '' &&
        //     !(end.includes('T') || start.includes('T'))) ||
        //   (end.includes('T') && start.includes('T'))
        // ) {
        //   end = moment(end).add(1, MomentEnum.days).format(MomentEnum.yearMonthDay);
        // }
        var resEvent = {
            id: event.id,
            allDay: event.isAllDay,
            start: start,
            end: end,
            title: event.title ? event.title : '',
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            description: event.summary,
            extendedProps: __assign(__assign({}, event), { pastEvent: pastEvent, tabIndex: tabIndex }),
        };
        return resEvent;
    });
    return __spreadArray([], convertedEvents, true);
};
//# sourceMappingURL=datesConvertToFCFormat.js.map